module.exports = __webpack_public_path__ + "img/Social_text02a_redistribute.127904a8.png";